/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({className, icon, id, onClick, title}) => {
    let buttonClass = 'ias-button ias-icon-button';
    if (className) {
        buttonClass += ' ' + className;
    }
    return (
        <button
            className={buttonClass}
            id={id}
            onClick={onClick}
            title={title}
            type="button"
        >
            <i className={`ias-icon ias-icon-${icon}`} />
        </button>
    );
};

IconButton.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string.isRequired,
    id: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
};

export default IconButton;
